import React from 'react'
import { motion } from "framer-motion";

import styles from "./SwitchQ.module.css"

const SwitchQ = ({ checked, onChange }) => {
  return (
    <div
      className={`${styles.switch} ${checked ? styles.checked : ""}`}
      onClick={onChange}
    >
      <motion.div
        className={styles.thumb}
        layout
        animate={{ x: checked ? 20 : -5 }}
        transition={{ type: "tween", duration: 0.1 }}
      />
    </div>
  );
}

export default SwitchQ